"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Sparkles, ArrowRight } from "lucide-react";

// Selected blog headlines to feature in the ticker. Update this array to
// change which articles are highlighted — order here is the scroll order.
const TICKER_ITEMS = [
  {
    label: "Why Vadodara's Sun, Smog & Festivals Are Ageing Your Skin Faster",
    href: "/news-and-articles/pigmentation-skin-aging-vadodara",
  },
  {
    label: "Regenerative Aesthetics & Biostimulator Treatments in Vadodara",
    href: "/news-and-articles/regenerative-aesthetics-biostimulator-treatments-vadodara",
  },
  {
    label: "Laser Hair Removal in Vadodara: Technology, Pricing & What to Expect",
    href: "/news-and-articles/laser-hair-removal-vadodara",
  },
  {
    label: "Bridal Skincare in Vadodara: Pre-Wedding Glow & Packages",
    href: "/news-and-articles/bridal-skincare-vadodara",
  },
  {
    label: "Semaglutide, Wegovy & Ozempic Weight Loss Injections in Vadodara",
    href: "/news-and-articles/semaglutide-wegovy-ozempic-weight-loss-vadodara",
  },
];

/**
 * NewsTicker Component
 * A slim, continuously auto-scrolling headline bar fixed to the very top
 * of every page (above the main header). Shows selected blog headlines
 * on a loop, each clickable, with a final "View All Articles" link.
 */
export function NewsTicker() {
  const pathname = usePathname();

  // Hide the ticker on dashboard and inventory pages — these are internal
  // admin/staff views where scrolling news headlines aren't wanted.
  const isHidden =
    pathname.startsWith("/dashboard") || pathname.startsWith("/inventory");

  if (isHidden) return null;

  // Build one repeating sequence: headline → headline → ... → View All CTA
  const items = [
    ...TICKER_ITEMS,
    { label: "View All Articles", href: "/news-and-articles", isCta: true },
  ];
  const trackItems = [...items, ...items];

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] h-9 overflow-hidden bg-gradient-to-r from-rose to-golden"
      aria-label="Latest news and articles"
    >
      <div className="animate-ticker-scroll flex w-max h-full items-center whitespace-nowrap will-change-transform">
        {trackItems.map((item, i) => (
          <Link
            key={i}
            href={item.href}
            className="mx-6 flex flex-shrink-0 items-center gap-1.5 text-xs font-semibold text-white hover:underline sm:text-sm"
          >
            {"isCta" in item && item.isCta ? (
              <>
                {item.label}
                <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
              </>
            ) : (
              <>
                <Sparkles className="h-3 w-3 flex-shrink-0" aria-hidden="true" />
                {item.label}
              </>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
